import { EdsContent } from './eds-content';
import { EdsMetaData } from './eds-metadata';

export class EdsDetails {
    public edsMetadata: EdsMetaData;
    public edsContent: EdsContent;
}
